import React from "react";
import moment from "moment";

import { getElementByUuid } from "utils/data/Content";

export const getTooltipLanguages = (languages, t) => {
  const childs = [];

  languages.forEach((lang, index) => {
    if (index < 2 || (index === 2 && languages.length === 3)) {
      childs.push(
        <span className="editor-tooltiptext-line">
          {t(`languages:langs.${lang.language}`)}
        </span>,
      );
    }
  });

  if (languages.length > 3) {
    childs.push(
      <span className="editor-tooltiptext-line">
        {t("common:more-other", { nb: languages.length - 2 })}
      </span>,
    );
  }

  return (
    <div className="editor-tooltiptext">
      <span className="editor-tooltiptext-line">{t("languages")}:</span>
      {childs}
    </div>
  );
};

export const getTooltipLanguagesV2 = (translations, t, languages) => {
  const childs = [];

  translations.forEach((lang, index) => {
    const { language_uuid } = lang;
    const language = getElementByUuid(language_uuid, languages);
    if (index < 2 || (index === 2 && translations.length === 3)) {
      childs.push(
        <span className="editor-tooltiptext-line">
          {t(`languages:langs.${language.language}`)}
        </span>,
      );
    }
  });

  if (translations.length > 3) {
    childs.push(
      <span className="editor-tooltiptext-line">
        {t("common:more-other", { nb: translations.length - 2 })}
      </span>,
    );
  }

  return (
    <div className="editor-tooltiptext">
      <span className="editor-tooltiptext-line">{t("languages")}:</span>
      {childs}
    </div>
  );
};

export const getTooltipOffers = (items, offers, t) => {
  const childs = [];

  items.forEach((item, index) => {
    if (index < 2 || (index === 2 && items.length === 3)) {
      const elt = getElementByUuid(item.uuid, offers);
      if (elt)
        childs.push(
          <span className="editor-tooltiptext-line">{elt.label}</span>,
        );
    }
  });

  if (items.length > 3) {
    childs.push(
      <span className="editor-tooltiptext-line">
        {t("common:more-other", { nb: items.length - 2 })}
      </span>,
    );
  }

  return (
    <div className="editor-tooltiptext">
      <span className="editor-tooltiptext-line">{t("offers")}:</span>
      {childs}
    </div>
  );
};

export const getTooltipTempoRestrict = (startDate, endDate, t) => {
  let tooltipText = "";

  if (!endDate) {
    tooltipText = t("common:available_start_at", {
      date: moment(startDate).format("LL"),
    });
  } else {
    tooltipText = t("common:available_start_end", {
      start_at: moment(startDate).format("LL"),
      end_at: moment(endDate).format("LL"),
    });
  }

  return <span className="editor-tooltiptext">{tooltipText}</span>;
};

export const getTooltipGeoRestrict = (items, geoblockMode, countries, t) => {
  const childs = [];

  if (geoblockMode === "allow") {
    childs.push(
      <span className="editor-tooltiptext-line">
        {t("common:allow_countries")}:
      </span>,
    );
  } else {
    childs.push(
      <span className="editor-tooltiptext-line">
        {t("common:disallow_countries")}:
      </span>,
    );
  }

  items.forEach((item, index) => {
    if (index < 2 || (index === 2 && items.length === 3)) {
      countries.data.forEach((c) => {
        if (item.uuid === c.uuid)
          childs.push(
            <span className="editor-tooltiptext-line">
              {t(`languages:countries:${c.country}`)}
            </span>,
          );
      });
    }
  });

  if (items.length > 3) {
    childs.push(
      <span className="editor-tooltiptext-line">
        {t("common:more-other", { nb: items.length - 2 })}
      </span>,
    );
  }

  return <span className="editor-tooltiptext">{childs}</span>;
};

export const getTooltipMultiline = (items) => (
  <div className="editor-tooltiptext">
    {items.map((item, idx) => (
      <span key={idx} className="editor-tooltiptext-line">
        {item}
      </span>
    ))}
  </div>
);

export const getTooltipContentStatus = (content, t) => {
  let tooltip =
    content?.status === "archived"
      ? t("common:archived")
      : t(`common:${content?.publication_status}`);

  if (content?.publication_status === "pause") {
    tooltip += ":\n";
    tooltip += content?.publication_reasons
      .map((reason) => t(`common:pause_reasons.${reason}`))
      .join("\n");
  }

  return tooltip;
};
